import Barredores from "@/views/Barredores.vue";

const barredores = {
  path: "/app/barredores",
  name: "barredores",
  component: Barredores
};

export default barredores;
